/* eslint-disable prettier/prettier */
import { Attachment, AttachmentSeed } from '../network/schema/models/index'

export interface IAttachmentProps extends Attachment {}
export interface IAttachmentSeed extends AttachmentSeed {}

export default class AttachmentEntity {
  private _props: IAttachmentProps

  constructor(props: IAttachmentProps) {
    this._props = props
  }

  get props(): IAttachmentProps {
    return this._props
  }

  get id(): number | undefined {
    return this.props.id
  }

  get name(): string {
    return this.props.name || ''
  }

  set name(value: string) {
    this.props.name = value
  }

  get originalName(): string {
    return this.props.originalName || ''
  }

  set originalName(value: string) {
    this.props.originalName = value
  }

  get description(): string {
    return this.props.description || ''
  }

  set description(value: string) {
    this.props.description = value
  }

  get url(): string | undefined {
    return this.props.url
  }

  get alt(): string | undefined {
    return this.originalName
  }

  get shortTitle(): string {
    const maxTitleLength = 20
    let title = this.originalName
    if (title?.length > maxTitleLength) {
      title = `${title.substr(0, maxTitleLength)}...`
    }
    return title
  }
}

export const EmptyAttachmentPropsFactory = (
  props?: Partial<IAttachmentProps>
): IAttachmentProps => ({
  ...props
})

export const AttachmentPropsFactory = (
  props?: Partial<IAttachmentProps>
): IAttachmentProps => ({
  ...props
})

export const EmptyAttachmentEntityFactory = (
  props?: Partial<IAttachmentProps>
): AttachmentEntity => {
  return new AttachmentEntity(EmptyAttachmentPropsFactory(props))
}

export const AttachmentEntityFactory = (
  props?: Partial<IAttachmentProps>
): AttachmentEntity => {
  return new AttachmentEntity(AttachmentPropsFactory(props))
}
